function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Incorrect email and/or password."
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Too many failed login attempts. Please try again in 5 minutes."
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Your account has been banned. Contact an event organizer to learn more."
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-self: center;\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: 'relative';\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 100;\n  padding: 0px 0px 10px 0px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Unknown error occurred while logging in."
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Please address the errors shown below"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Email Address"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Email Address is required."
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "Invalid email address."
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "Password"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "Password is required."
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "Forgot your password?"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "Logging in..."
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "Log in"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
import React, { useState, useCallback } from "react";
import styled from "styled-components";
import { Alert, Button, Form as AntForm, Input, message, Typography } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { t } from "ttag";
import { useHistory } from "react-router-dom";
import useSearchParams from "../../../hooks/useSearchParams";
import Label from "../../Label";
import Layout from "../Layout";
var ERROR_MESSAGES_BY_CODE = function() {
    return {
        invalid_email_or_password: t(_templateObject()),
        too_many_failed_logins: t(_templateObject1()),
        banned_user: t(_templateObject2())
    };
};
var AntTitle = Typography.Title;
var Title = styled(AntTitle)(_templateObject3());
var Form = styled(AntForm)(_templateObject4());
var PasswordItem = styled(AntForm.Item)(_templateObject5());
var PasswordLink = styled(Button)(_templateObject6());
var useForm = AntForm.useForm;
var PasswordIconRenderer = function(visible) {
    return visible ? /*#__PURE__*/ React.createElement(EyeTwoTone, null) : /*#__PURE__*/ React.createElement(EyeInvisibleOutlined, null);
};
var LoginPresentation = function(param) {
    var title = param.title, userFlagFn = param.userFlagFn, loginFn = param.loginFn, setUserAndFlags = param.setUserAndFlags, _param_afterLogin = param.afterLogin, afterLogin = _param_afterLogin === void 0 ? null : _param_afterLogin, _param_redirectUrl = param.redirectUrl, redirectUrl = _param_redirectUrl === void 0 ? "/" : _param_redirectUrl;
    var _useForm = _slicedToArray(useForm(), 1), form = _useForm[0];
    var validateFields = form.validateFields, getFieldValue = form.getFieldValue;
    var _useState = _slicedToArray(useState(""), 2), error = _useState[0], setError = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), loading = _useState1[0], setLoading = _useState1[1];
    var history = useHistory();
    var query = useSearchParams();
    var redirect = useCallback(function() {
        var redirectTo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
        var next = query.get("next");
        if (next && next !== "/login") {
            return history.push(next);
        }
        return history.push(redirectTo);
    }, [
        history,
        query
    ]);
    var onFinish = function() {
        var _ref = _asyncToGenerator(function() {
            var values, payload, user, _ref, flags, err, _err_errors, _err_errors_, _ERROR_MESSAGES_BY_CODE_err_errors__code, errorMessage;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setError("");
                        setLoading(true);
                        return [
                            4,
                            validateFields()
                        ];
                    case 1:
                        values = _state.sent();
                        payload = {
                            email: values.email,
                            password: values.password
                        };
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            loginFn(payload)
                        ];
                    case 3:
                        user = _state.sent();
                        return [
                            4,
                            userFlagFn(user.userId)
                        ];
                    case 4:
                        _ref = _state.sent(), flags = _ref.data;
                        setUserAndFlags(user, flags);
                        if (!afterLogin) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            afterLogin(user)
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        redirect(redirectUrl);
                        return [
                            3,
                            8
                        ];
                    case 7:
                        err = _state.sent();
                        errorMessage = (_ERROR_MESSAGES_BY_CODE_err_errors__code = ERROR_MESSAGES_BY_CODE()[err === null || err === void 0 ? void 0 : (_err_errors = err.errors) === null || _err_errors === void 0 ? void 0 : (_err_errors_ = _err_errors[0]) === null || _err_errors_ === void 0 ? void 0 : _err_errors_.code]) !== null && _ERROR_MESSAGES_BY_CODE_err_errors__code !== void 0 ? _ERROR_MESSAGES_BY_CODE_err_errors__code : t(_templateObject7());
                        setError(errorMessage);
                        setLoading(false);
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFinish() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        hideRequiredMark: true,
        onFinish: onFinish,
        onFinishFailed: function() {
            return message.error(t(_templateObject8()));
        },
        initialValues: {
            email: "",
            password: ""
        }
    }, /*#__PURE__*/ React.createElement(Title, {
        level: 4
    }, title), error && /*#__PURE__*/ React.createElement(Alert, {
        message: error,
        type: "error",
        style: {
            marginBottom: "24px",
            width: "100%",
            border: 0
        },
        showIcon: true
    }), /*#__PURE__*/ React.createElement(AntForm.Item, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject9())),
        name: "email",
        rules: [
            {
                required: true,
                message: t(_templateObject10())
            },
            {
                type: "email",
                message: t(_templateObject11())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, {
        "data-testid": "email"
    })), /*#__PURE__*/ React.createElement(PasswordItem, null, /*#__PURE__*/ React.createElement(AntForm.Item, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject12())),
        name: "password",
        rules: [
            {
                required: true,
                message: t(_templateObject13())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input.Password, {
        "data-testid": "password",
        iconRender: PasswordIconRenderer
    })), /*#__PURE__*/ React.createElement(PasswordLink, {
        type: "link",
        onClick: function() {
            return history.replace("/forgot-password");
        }
    }, t(_templateObject14()))), /*#__PURE__*/ React.createElement(AntForm.Item, {
        shouldUpdate: true,
        noStyle: true
    }, function() {
        return /*#__PURE__*/ React.createElement(Button, {
            block: true,
            type: "primary",
            htmlType: "submit",
            loading: loading,
            disabled: !(getFieldValue("email") && getFieldValue("password"))
        }, loading ? t(_templateObject15()) : t(_templateObject16()));
    })));
};
export default LoginPresentation;
